
// In the browser these values are defined through loading their respective lib files
// But in node, they are imported through 'require'; they need to be defined here globally, though
var Math = (typeof Math === 'undefined') ? undefined : Math;
var Jimp = (typeof Jimp === 'undefined') ? undefined : Jimp;
var jsPDF = (typeof jsPDF === 'undefined') ? undefined : jsPDF;
var UI_STRINGS = (typeof UI_STRINGS === 'undefined') ? undefined : UI_STRINGS;
if (typeof window === 'undefined') {
  Math = require("mathjs"); //nodejs replacement for in-browser math lib
  Jimp = require("jimp");
  jsPDF = require("jspdf").jsPDF;
  UI_STRINGS = require('./uiStrings').UI_STRINGS;
  module.exports = {exportPDFData};
}
  

function toUiTxt(key) {
	for (el of UI_STRINGS) {
  	if (el[0] == key)
    	return el[1][0][1];
  }
  return '-';
};

function getEcologicalInterest(finalBiodivGrade) {
  switch(finalBiodivGrade) {
    case 5:
      return "Très élevé";
      break;
    case 4:
      return "Elevé";
      break;
    case 3:
      return "Plutôt élevé";
      break;
    case 2:
      return "Moyen";
      break;
    case 1:
      return "Faible";
      break;
    case 0:
      return "Très faible";
      break;
    default:
      return "";
      break;
  }
};

async function exportPDFData(pdfPath, data) {
 
  var pdf = new jsPDF({
    orientation: 'l',
    unit: 'mm',
    format: 'a4',
    putOnlyUsedFonts: true
  });

  const thedate = dateToFormattedString(new Date(data.isolatedTree.collection_date));
  
  const raw = data.isolatedTree;
  let docOpts = {
    pageDim : { x : 297, y : 210 },
    titlePosY : 10,
    titleOffset : 10,
    paragraphOffset : { x : 0, y : 3 },
    sectionOffset : { x : 10, y : 0 },
    itemsOffset : { x : 1, y : 6 },
    itemsColumnWidth : [[25,30],[20,15],[35,23],[25,15]],
    itemsStartingPos : { x : 10, y : 150 },
    commentsColumnWidth : 45,
    maxCommentLength : 450,
    charWidth : 0.8,
    fontSize : 7,
    headerFooterFontSize : 8,
    maxStringLength : 30,
    title : raw.variety.latin_name + " | " + raw.variety.common_name,
    header :
      { left : "Date du relevé : " + dateToFormattedString(new Date(raw.collection_date)),
        right : "Inventaire des arbres remarquables"
      },
    footer :
      { left : "",
        right : "Date d'exportation : " + dateToFormattedString(new Date())
      }
  };
  
  const defaultStr = "-";
  let pi = Math.PI || Math.pi; //Depending of the lib (browser or node)
  let age = defaultStr;
  if (raw.year_of_planting)
    age = ((new Date()).getFullYear() - raw.year_of_planting).toString() + ' ans';
  else if (raw.is_more_than_100_years === true)
    age = toUiTxt("data_isolatedTree_isMoreThan100Years_yes");
  else if (raw.is_more_than_100_years === false)
    age = toUiTxt("data_isolatedTree_isMoreThan100Years_no");

  let isolatedTree = {
    "sections" : [
      {	"Localisation" : [
          {"Commune" : raw.commune},
          {"Appellation locale" : raw.name || defaultStr},
          {"Coordonnées" : numberToFormattedString(raw.geometry.coordinates[0]) + " | " + numberToFormattedString(raw.geometry.coordinates[1])},
          {"N° de parcelle" : raw.plot_nb}
        ]
      },
      {	"Caractéristiques" : [
          {"Circonférence" : raw.circumference + " cm"},
          {"Diamètre" : (Math.round(((raw.circumference / pi) + Number.EPSILON) * 100) / 100) + " cm"}
        ]
      },
      { "Critères" : [
          {"Age" : age},
          {"Couronne" : toUiTxt(raw.crown_development)},
          {"Intérêt écologique" : getEcologicalInterest(raw.variety.final_biodiv_grade)},
          {"Intérêt paysager" : (raw.has_landscape_interest) ? toUiTxt("data_option_strong") : toUiTxt("data_option_common")},
          {"Fait partie d'un ensemble" : (raw.is_part_of_a_group) ? toUiTxt("data_option_yes") : toUiTxt("data_option_no")},
          {"Intérêt socio-historique" : (raw.has_socio_historical_interest) ? toUiTxt("data_option_strong") : toUiTxt("data_option_common")},
          {"Just. de l'int. socio-hist." : toUiTxt(raw.socio_historical_interest)},
          {"Intérêt ecosystémique" : toUiTxt(raw.ecosystem_situation)}
        ]
      },
      { "_" : [
          { "Notation" :
              [ {"Nombre de points" : raw.total_score + " points"},
                {"Importance" : (raw.is_of_regional_importance) ? toUiTxt("data_isolatedTree_isOfRegionalImportance_yes") : toUiTxt("data_isolatedTree_isOfRegionalImportance_no")}
              ]
          },
          { "Justification de mise à l'inv." : raw.justification_of_ranking || "Aucune." }
       ]
      }
    ],
    "comments" : raw.comments || ""
  }
  
  try {
    const treePicture = await loadAndCropImage(data.treePictureURL, 85, 115);
    const mainMap = data.mainMap;

    addImageWithBorder(pdf, treePicture, 10, 20, 85, 115);
    addImageWithBorder(pdf, mainMap, 100, 20, 187, 115);

    addTitle(pdf, docOpts.pageDim, docOpts.title, docOpts.titlePosY);
    addHeaderFooter(pdf, docOpts.pageDim, docOpts.headerFooterFontSize, docOpts.header, docOpts.footer);
    addIsolatedTreeToPDF(pdf, isolatedTree, docOpts);

    pdf.save(pdfPath);
  } catch (e) {
    console.error(e);
  }
};



/// Helpers

function addHeaderFooter(pdf, pageDim, headerFooterFontSize, header, footer) {
  pdf.setFontSize(headerFooterFontSize);
  pdf.text(header.left, 10, 5, { align: 'left', baseline: 'top' });
  pdf.text(header.right, pageDim.x-10, 5, { align: 'right', baseline: 'top' });
  pdf.text(footer.left, 10, pageDim.y - 5, { align: 'left' });
  pdf.text(footer.right, pageDim.x - 10, pageDim.y - 5, { align: 'right' });
}


function addTitle(pdf, pageDim, title, posY) {
  pdf.setFont(undefined, 'bold');
  pdf.text(title, pageDim.x/2, posY, { align: 'center', baseline: 'top' });
  pdf.setFont(undefined, 'normal');
}


function addItems(pdf, items, startingPos, itemsOffset, maxStringLength, isLabels) {
  let pos = startingPos;
  
  if (isLabels)
    pdf.setFont(undefined, 'bold');

  for(let i = 0; i < items.length; i++) {
    pdf.text(truncateString(items[i], maxStringLength), pos.x, pos.y);
    pos = addOffsets(pos, { x : 0, y : itemsOffset.y });
  }
  pdf.setFont(undefined, 'normal');
  return pos;
}


function addComments(pdf, comments, startingPos, maxLength) {
  pdf.text(truncateString(comments, maxLength), startingPos.x, startingPos.y, { 'align' : 'left'});
}


function addSectionTitle(pdf, title, pos) {
  const fontIncreaseFactor = 3;
  pdf.setFontSize(pdf.getFontSize() + fontIncreaseFactor);
  pdf.setFont(undefined, 'bold');
  pdf.text(title, pos.x, pos.y, { align: 'center', baseline: 'top' });
  pdf.setFont(undefined, 'normal');
  pdf.setFontSize(pdf.getFontSize() - fontIncreaseFactor);
}

function addSection(pdf, data, startingPos, itemsOffset, itemsColumnWidth, charWidth, sectionOffset, paragraphOffset, isInnerSection = false) {
  let sectionTitle = Object.keys(data)[0];
  let sectionItems = data[sectionTitle];
  let key, value;
  let labels = [], values = [];
  let pos = startingPos;

  if (!Array.isArray(sectionItems)) {
    addCommentsSection(pdf, sectionItems, pos, 45, charWidth, 450, sectionTitle);
    pos = addOffsets(startingPos, { x : itemsColumnWidth[0] + itemsOffset.x, y : 0});
    return addOffsets(pos, { x : itemsColumnWidth[1], y : 0});
  }

  if (sectionTitle == '_') {
    let pos = startingPos;
    for (let section of sectionItems) {
      pos = addSectionAndOffsets(pdf, section, pos, itemsOffset, itemsColumnWidth, charWidth, sectionOffset, paragraphOffset, true);
    }
    pos = addOffsets(startingPos, { x : itemsColumnWidth[0] + itemsOffset.x, y : 0});
    return addOffsets(pos, { x : itemsColumnWidth[1], y : 0});
  }
  
  for (let i = 0; i < sectionItems.length; i++) {
  	key = Object.keys(sectionItems[i])[0];
    value = sectionItems[i][key];
    labels.push(key);
    values.push(value);
  }
  
  addSectionTitle(pdf, sectionTitle, { x : pos.x + ((itemsColumnWidth[0] + itemsColumnWidth[1]) / 2), y : startingPos.y - 10 })
  addItems(pdf, labels, pos, itemsOffset, itemsColumnWidth[0] * charWidth, true);
  pos = addOffsets(startingPos, { x : itemsColumnWidth[0] + itemsOffset.x, y : 0});

  if (isInnerSection) {
    pos = addItems(pdf, values, pos, itemsOffset, itemsColumnWidth[1] * charWidth, false);
    pos = { x : startingPos.x, y : pos.y };
  } else {
    addItems(pdf, values, pos, itemsOffset, itemsColumnWidth[1] * charWidth, false);
  }

  return (isInnerSection) ? pos : addOffsets(pos, { x : itemsColumnWidth[1], y : 0});
}


function replaceCharacter(string, index, replacement) {
  return string.slice(0, index) + replacement + string.slice(index + 1);
}


function addCommentsSection(pdf, comments, startingPos, commentsColumnWidth, charWidth, maxCommentLength, sectionTitle = undefined) {
	const commentsTitle = (sectionTitle) ? sectionTitle : "Commentaires";
  let commentsBody = comments;
  let maxLineLength = commentsColumnWidth * charWidth;
  let lastSpaceIndex = 0;
  let returnCarriageFactor = 1;
  
  addSectionTitle(pdf, commentsTitle, { x : startingPos.x + (commentsColumnWidth / 2), y : startingPos.y - 10 });
  for (let i = 0; i < commentsBody.length; i++) {
    if (commentsBody[i] == ' ')
    	lastSpaceIndex = i;
    
    if (i > maxLineLength * returnCarriageFactor) {
    	commentsBody = replaceCharacter(commentsBody, lastSpaceIndex, '\n');
    	returnCarriageFactor++;
    }
  }
  addComments(pdf, commentsBody, startingPos, maxCommentLength);
}

function addSectionAndOffsets(pdf, data, startingPos, itemsOffset, itemsColumnWidth, charWidth, sectionOffset, paragraphOffset, isInnerSection = false) {
  let pos = startingPos;
  pos = addSection(pdf, data, pos, itemsOffset, itemsColumnWidth, charWidth, sectionOffset, paragraphOffset, isInnerSection);
  if (isInnerSection)
    pos = addOffsets(pos, { x : 0, y : 10 });
  else
    pos = addOffsets(pos, sectionOffset);
  return pos;
}

function addIsolatedTreeToPDF(pdf, isolatedTree, docOpts) {	
	const sections = isolatedTree.sections;
  const comments = isolatedTree.comments;
  let pos = docOpts.itemsStartingPos;
  
  pdf.setFontSize(docOpts.fontSize);
	for (let i = 0; i < sections.length; i++) {
    pos = addSectionAndOffsets(pdf, sections[i], pos, docOpts.itemsOffset, docOpts.itemsColumnWidth[i], docOpts.charWidth, docOpts.sectionOffset, docOpts.paragraphOffset);
  }
  addCommentsSection(pdf, comments, pos, docOpts.commentsColumnWidth, docOpts.charWidth, docOpts.maxCommentLength);
}


/* Compute the optimal cropping based on the image size */
const loadAndCropImage = function (source, destWidth, destHeight) {
  return new Promise ((resolve, reject) => {
    Jimp.read(source, async (err, img) => {
      if (err) reject(err);

      try {
        const width = img.bitmap.width;
        const height = img.bitmap.height;
        const ratioWidth = width / destWidth;
        const ratioHeight = height / destHeight;

        if (isCloserToOne(ratioWidth, ratioHeight)) {
          const deltaCropY = (height - destHeight * ratioWidth);
          if (height > destHeight) {
            img.crop(
              0,
              deltaCropY / 2,
              width,
              (height - (deltaCropY / 2)) - (deltaCropY / 2)
            );
          }
        } else {
          const deltaCropX = (width - destWidth * ratioHeight);
          if (width > destWidth) {
            img.crop(
              deltaCropX / 2,
              0,
              (width - (deltaCropX / 2)) - (deltaCropX / 2),
              height
            );
          }
        }
        
        const toPixel = (mm) => Math.floor(mm * 3.7795275591);
        img.resize(toPixel(destWidth), toPixel(destHeight));

        const imgB64 = await img.getBase64Async(img.getMIME());
        resolve(imgB64);
      } catch (err) {
        reject(err)
      }
    });
  });
};

/* Check if the first param is closer to 1 (perfect ratio) than the second param */
const isCloserToOne = function (evalRatio, ratio2) {
  var r1 = (1 - evalRatio);
  var r2 = (1 - ratio2);
  r1 = (r1 < 0) ? r1 * -1 : r1
  r2 = (r2 < 0) ? r2 * -1 : r2
  return (r1 < r2);
};

/* Add image with border to PDF */
const addImageWithBorder = function (pdf, imgB64, x, y, width, height) {
  try {
    pdf.addImage(
      imgB64,
      'PNG',
      x,
      y,
      width,
      height,
      "",
      "MEDIUM");
    pdf.rect(x, y, width, height);
  } catch (e) {
    console.error(e);
  }
};

/* Truncate string with "..." after {num} characters */
function truncateString(str, num) {
  if (str == undefined) return "";
  if (str.length <= num) {
    return str
  }
  str = str.toString();
  return str.slice(0, num) + '...';
}

/* Converts a Date into a String with format dd.mm.yyy */
const dateToFormattedString = function (date) {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return dd + '.' + mm + '.' + yyyy;
}

/* Converts a number into a String adding the thousands seperators */
const numberToFormattedString = function (num) {
  const numStr = num.toString();
	let res = [];
  let countQuote = 0;
	for(let i = numStr.length - 1; i >= 0; i--) {
  	res.unshift(numStr[i]);
    if ((res.length - countQuote) % 3 == 0) {
    	res.unshift("'");
      countQuote++;
    }
  }
  return res.join("");
}

/* Addition two offset object {x, y} */
function addOffsets(o1, o2) {
  return {x : o1.x + o2.x, y : o1.y + o2.y};
}
